import { useContent } from '../ContentContext';

export default function Floaters() {
  const { company } = useContent();
  const phone = (company.phones || [])[0];
  const wa = `https://wa.me/${company.whatsapp}?text=${encodeURIComponent(company.whatsappText || '')}`;

  return (
    <div className="floaters">
      {phone ? (
        <a className="float-call" href={`tel:+91${phone}`} aria-label="Call us">
          <i className="fas fa-phone" />
        </a>
      ) : null}
      {company.whatsapp ? (
        <a className="float-wa" href={wa} target="_blank" rel="noreferrer" aria-label="WhatsApp">
          <i className="fab fa-whatsapp" />
        </a>
      ) : null}
    </div>
  );
}
